import React, {createContext, useContext, useState, useCallback, useEffect} from 'react';
import {useHistory} from "react-router-dom";
import {isEqual, isFunction} from "lodash";
import * as actions from '../../_common/actions/generalData';
const UsersActionsUIContext = createContext('');

export function useUsersActionsUIContext() {
  return useContext(UsersActionsUIContext);
}

export function UsersActionsUIProvider({children}) {
  const history = useHistory();
  const [queryParams, setQueryParamsBase] = useState({});
  const setQueryParams = useCallback(nextQueryParams => {
    setQueryParamsBase(prevQueryParams => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }
      for (let key in nextQueryParams) {
        if (nextQueryParams.hasOwnProperty(key) && !nextQueryParams[key]) delete nextQueryParams[key]
      }
      const path = history.location.pathname;
      const newQueryParams = new URLSearchParams(nextQueryParams);
      history.replace(`${path}?${newQueryParams.toString()}`);

      return nextQueryParams;
    });
  }, []);

  const initialOptions = {
    actions: [],
    sources: [],
    statuses: []
  };
  const [options, setOptions] = useState(initialOptions);

  useEffect(() => {
    actions.getUsersActionsOptions()
      .then(setOptions)
      .catch((e) => {
        console.error(e);
        setOptions(initialOptions);
      });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    actionsOptions: options?.actions ? options.actions : [],
    sourcesOptions: options?.sources ? options.sources : [],
    statusesOptions: options?.statuses ? options.statuses : [],
  };

  return <UsersActionsUIContext.Provider value={value}>{children}</UsersActionsUIContext.Provider>;
}
